import { TableCell, styled as muiStyled } from '@mui/material';
import styled from 'styled-components';

export const TableCellHeader = muiStyled(TableCell)(() => ({
  fontFamily: 'Work Sans',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '18px',
  color: 'var(--luft-secondary-dark)'
}));

export const TableCellBody = muiStyled(TableCell)(() => ({
  fontFamily: 'Work Sans',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '20px',
  color: 'rgba(0, 0, 0, 0.87)'
}));

export const PerformanaceContent = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 4px;
  }
`;

export const PerformanceBarValues = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const PerformanceBar = styled.div`
  display: flex;  
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 4px;
`;

export const PerformanceFraction = styled.div`
  display: flex;
  margin-top: 4px; 
  background: rgba(46, 125, 50, 0.12);
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  color: #000;
  gap: 4px;
`;

export const ArrowDownContainer = styled.div`
  display: flex;
  gap: 16px;
`;

export const ShippingContainer = styled.div`
  max-height: 440px;
  overflow-y: auto;
`;

export const ShippingTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ShippingTableHeader = styled.div`
  display: flex;
  flex-direction: row;
  font-weight: bold;
  border-bottom: 1px solid #00000061;
`;

export const ShippingTableRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid #ccc;
  align-items: center;
  min-height: 88px;
`;

export const ShippingTableCellHeader = styled.div`
  flex: 1;
  padding: 16px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: var(--luft-secondary-dark);
`;

export const ShippingTableCellBody = styled.div`
  flex: 1;
  padding: 16px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.87);
`;

export const ShippingPerformanaceContent = styled.div`
  display: flex;
  align-items: center;

  > svg {
    margin-right: 4px;
  }
`;

export const ShippingPerformanceFraction = styled.div`
  display: flex;
  margin-top: 4px;
  background: rgba(46, 125, 50, 0.12);
  border-radius: 4px;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  color: #000;
  gap: 4px;
`;

export const ShippingArrowDownContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ShippingCompanyContainer = styled.div`
  margin: 16px;
  background-color: rgba(38, 52, 101, 0.08);
  border-radius: 8px;
  padding: 8px;
  display: flex;
  flex-direction: column;
`;

export const ShippingStyledTableRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const ShippingDefaultTableCell = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  align-items: center;

  > svg {
    margin-right: 4px;
  }
`;

export const ShippingCompanyName = styled(ShippingDefaultTableCell)`
  gap: 16px;
`;

export const ShippingStyledImage = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`;
